import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import BrandedHubPromo from "../components/BrandedHubPromo";
import useScrollDepthTracking from "../utils/useScrollDepthTracking";

export default function MarketingLayout() {
  useScrollDepthTracking();
  return (
    <>
      <Outlet />
      <Footer />
      <BrandedHubPromo />
    </>
  );
}
